<template>
    <div id="channel-apk">
        <div class="img-box">
            <div class="top_part">
                <img class="top-back-img" src="@/assets/channel-apk/1.png" alt="">
                <div class="down-btn" @click="downApk"></div>
                <div class="link-wrapper">
                    <div>
                        <img class="icon" src="@/assets/channel-apk/i1.png" alt="">
                        <a href="https://t.me/jgzenglish" target="">https://t.me/jgzenglish</a>
                        <span class="copy my_code" @click="copy('https://t.me/jgzenglish')">
                            <img class="mr4" src="@/assets/channel-apk/copy.png">
                        </span>
                    </div>
                    <div>
                        <img class="icon" src="@/assets/channel-apk/i2.png" alt="">
                        <a href="https://twitter.com/JGZPRO" target="">https://twitter.com/JGZPRO</a>
                        <span class="copy my_code" @click="copy('https://twitter.com/JGZPRO')">
                            <img src="@/assets/channel-apk/copy.png">
                        </span>
                    </div>
                    <div>
                        <img class="icon" src="@/assets/channel-apk/i3.png" alt="">
                        <a href="https://chat.whatsapp.com/HobclROKu2HGZKTkoewmUN" target="">https://chat.whatsapp.com/HobclROKu2HGZKTkoewmUN</a>
                        <span class="copy my_code" @click="copy('https://chat.whatsapp.com/HobclROKu2HGZKTkoewmUN')">
                            <img src="@/assets/channel-apk/copy.png">
                        </span>
                    </div>
                </div>
            </div>
            <div class="middle-part">
                <img src="@/assets/channel-apk/2.png" alt="">
            </div>
            <div class="third-part">
                <img src="@/assets/channel-apk/3.png" alt="">
            </div>
            <div class="four-part">
                <img src="@/assets/channel-apk/4.png" alt="">
                <div class="down-btn" @click="downApk"></div>
            </div>
          
            <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
                <span class="mask-tip">请在浏览器中打开</span>
                <img src="@/assets/down/tip_arrow.png"/>
            </div>
        </div>
        <div class="alert" v-show="alertShow">
            <span>{{message}}</span>
        </div>
    </div>
</template>
  
<script>
import Clipboard from 'clipboard'
export default {
    data() {
        return {
            alertShow: false,
            message: ''
        }
    },
    methods: {
        downApk() {
            const androidUrl = 'https://f.jgzdata.com/apk/2/jgz-release_trade_v4.2.2-RELEASE_10-28_jgz_channel_VLJEAF_422-RELEASE_jiagu_sign.apk'
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = "javascript: '<script>location.href=\"" + androidUrl + "\"<\/script>'";
            document.getElementsByTagName('body')[0].appendChild(iframe);
        },
        copy(str) {
            // let str = 'https://t.me/jgzcom'
            let clipboard = new Clipboard('.my_code', {
                text: function () {
                    return str
                }
            })
            console.log(clipboard)
            clipboard.on('success', e => {
                this.showAlert('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.showAlert('复制失败，请长按邀请码进行复制')
                clipboard.destroy()
            })
        },
        showAlert(message) {
            this.message = message;
            this.alertShow = true;
            setTimeout(() => {
                this.alertShow = false;
            }, 1500);
        },
    }
}
</script>
  
<style lang='less'>
#channel-apk {
    height: 100vh;
    width: 100vw;
    background: #111125;;
    position: relative;
    // padding-bottom: 120px;
    img {
        pointer-events: none;
    }
    button {
        height: 90px;
        width: 460px;
        outline: none;
        border: none;
        cursor: pointer;
        border-radius: 45px;
        background: linear-gradient(90deg,#ff7800 0%, #ffc000 100%);
        box-shadow: -5px 0px 0px 0px rgba(255,207,152,0.81);
        position: absolute;
        color: #ffffff;
        font-size: 32px;
        font-weight: bold;
        left: 145px;
    }
    .img-box {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    .down-btn {
        height: 100px;
        width: 600px;
        opacity: 0;
        position: absolute;
    }
    .top_part {
        width: 100vw;
        height: 1659px;
        position: relative;
        .top-back-img {
            // position: absolute;
            // left: 0;
            // top: 0;
            width: 100vw;
        }
        .down-btn {
            left: 75px;
            top: 440px;
        }
        .link-wrapper {
            position: absolute;
            color: #ffffff;
            left: 125px;
            bottom: 62px;
            // width: 100vw;
            text-align: left;
            div {
                margin-bottom: 40px;
            }
            span {
                // margin-right: 20px;
                font-size: 28px;
                vertical-align: middle;
            }
            a {
                color: #ffffff;
                margin-right: 10px;
                vertical-align: middle;
                display: inline-block;
                max-width: 397px;
                // text-overflow: wrap;
                word-wrap: break-word;
                line-height: 40px;
                font-size: 28px;
            }
            .icon {
                width: 40px;
                height: 40px;
                vertical-align: middle;
                margin-right: 10px;
            }
            .copy {
                img {
                    width: 40px;
                    height: 40px;
                    vertical-align: middle;
                }
            }
        }
    }
    .middle-part {
        position: relative;
        img {
            width: 100vw;
        }
        .button_box {
            width: 60vw;
            position: absolute;
            top: 265px;
            right: 40px;
            height: 90px;
            opacity: 0;
        }
        button {
            left: 0;
        }
    }
    .third-part {
        img {
            width: 100vw;
        }
    }
    .third-part-1 {
        img {
            width: 100vw;
        }
    }
    .four-part {
        position: relative;
        img {
            width: 100vw;
        }
        .down-btn {
            left: 75px;
            bottom: 85px;
        }
    }
    .alert {
        position: fixed;
        z-index: 3;
        top: 40%;
        left: 50%;
        height: 60px;
        width: auto;
        padding: 0 30px;
        transform: translateX(-100px);
        border-radius: 8px;
        background: rgba(0, 0, 0, .9);
        color: #ffffff;
        line-height: 60px;
    }
}
</style>
      